import { collection, addDoc, getDocs, query, orderBy, doc, updateDoc, deleteDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface Testimonial {
  id?: string;
  name: string;
  location: string;
  rating: number;
  comment: string;
  avatar?: string;
  isActive: boolean;
  createdAt: Timestamp;
}

// Get all active testimonials
export const getActiveTestimonials = async (): Promise<Testimonial[]> => {
  try {
    const q = query(collection(db, 'testimonials'), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const allTestimonials = querySnapshot.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data() 
    } as Testimonial));
    
    const activeTestimonials = allTestimonials.filter(testimonial => testimonial.isActive);
    
    return activeTestimonials;
  } catch (error) {
    console.error('Error getting testimonials:', error);
    return [];
  }
};

// Admin functions
export const getAllTestimonials = async (): Promise<Testimonial[]> => {
  try {
    const q = query(collection(db, 'testimonials'), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as Testimonial));
  } catch (error) {
    console.error('Error getting all testimonials:', error);
    throw error;
  }
};

export const createTestimonial = async (testimonialData: Omit<Testimonial, 'id' | 'createdAt'>): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, 'testimonials'), {
      ...testimonialData,
      createdAt: Timestamp.now()
    });
    return docRef.id;
  } catch (error) {
    console.error('Error creating testimonial:', error);
    throw error;
  }
};

export const updateTestimonial = async (id: string, updates: Partial<Testimonial>): Promise<void> => {
  try {
    const testimonialRef = doc(db, 'testimonials', id);
    await updateDoc(testimonialRef, updates);
  } catch (error) {
    console.error('Error updating testimonial:', error);
    throw error;
  }
};

export const deleteTestimonial = async (id: string): Promise<void> => {
  try {
    await deleteDoc(doc(db, 'testimonials', id));
  } catch (error) {
    console.error('Error deleting testimonial:', error);
    throw error;
  }
};
